import React from "react";
import TagManager from "react-gtm-module";
// import ReactPixel from 'react-facebook-pixel'
import Pixel from "./pixel";

export const LoanReview = () => {
  //TAG MANAGER
  const tagManagerArgs = {
    dataLayer: {
      event: "pageChange",
      page: {
        url: "/loan-review",
        referrer: sessionStorage.getItem("utm") || "/",
      },
    },
    dataLayerName: "dataLayer",
  };
  TagManager.dataLayer(tagManagerArgs);

  return (
    <div className="bg-white relative w-full flex justify-center flex-1">
      <div className="container flex flex-col gap-8 px-4 py-12 mb-32">
        <div className="w-full flex flex-col gap-4">
          <h1 className="text-3xl font-extra-bold text-green-primary">Estamos trabajando en tu solicitud</h1>
          <h2 className="text-xl">Nos pondremos en contacto contigo una vez que completemos la revisión de tu información.</h2>

          <Pixel name="PIXEL 1" />
        </div>
      </div>
    </div>
  );
};
